import React, { useRef } from "react";
import DataTable from "react-data-table-component";

import useStickyTableHead from "../../helpers/use-sticky-table-head";

// Drop-in DataTable that grows with its rows and keeps the header pinned while the page
// scrolls. fixedHeader is ignored because it caps the body height and scrolls inside it.
// The header's z-index is confined to .rdt_Table (index.css) so page menus and modals stay on top.
const StickyHeaderDataTable = ({ fixedHeader, fixedHeaderScrollHeight, ...props }) => {
  const containerRef = useRef(null);
  useStickyTableHead(containerRef);

  return (
    <div ref={containerRef} className="sticky-head-table">
      <DataTable {...props} />
    </div>
  );
};

export default StickyHeaderDataTable;
